import { TMessageSchema } from '../../types/messages';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { isMessageDeleted } from './isMessageDeleted';

interface IIsMessageReadParams {
  rawMessage: TMessageSchema;
  isOutcoming: boolean;
}

/** Проверяет, прочитано ли сообщение. */
export function isMessageRead({ rawMessage, isOutcoming }: IIsMessageReadParams): boolean {
  return (
    isMessageDeleted(rawMessage) ||
    rawMessage.status === 'readByRecipient' ||
    (rawMessage.chatId === CHATBOT_ID && !rawMessage.unread && !isOutcoming)
  );
}
